export default __webpack_public_path__ + "static/media/474.1dd44558.png";